// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"0":"codemirror","3":"react-movable","4":"react-sortable-hoc"}[chunkId] || chunkId) + ".min.js?" + {"0":"017e55e68bacddcec2af","3":"84257ba4c8354da49e75","4":"f26f215089f1a1484028","5":"baa8da67170fccb34b27"}[chunkId] + "";
};